module.exports = __webpack_public_path__ + "img/like-white.3de106ec.svg";